import { useTranslation } from 'react-i18next';

const places = [
  { img: '/images/generated/master-situations-2026.jpg' },
  { img: '/images/generated/hotel-scenario-1.jpg' },
  { img: '/images/generated/luxury-sales-scenario-2.jpg' },
];

function splitParagraphs(text: string): string[] {
  return text.split(/\n{2,}/).filter((part) => part.length > 0);
}

export default function Workplaces() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('butlerJob.places.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('butlerJob.places.title')}
          </h2>
          <p className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">
            {t('butlerJob.places.titleEn')}
          </p>
          <div className="gold-line mx-auto mb-6"></div>
          {splitParagraphs(t('butlerJob.places.lead')).map((para, i) => (
            <p key={i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">
              {para}
            </p>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {places.map((place, idx) => (
            <div
              key={idx}
              className="card-glow bg-background-50 border border-background-200/60 overflow-hidden flex flex-col"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={place.img}
                  alt={t(`butlerJob.places.${idx}.imgAlt`)}
                  className="absolute inset-0 w-full h-full object-cover object-center"
                />
              </div>
              <div className="p-6 md:p-7">
                <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-3">
                  {t(`butlerJob.places.${idx}.title`)}
                </h3>
                {splitParagraphs(t(`butlerJob.places.${idx}.desc`)).map((para, i) => (
                  <p key={i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-[1.85]">
                    {para}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>

        {splitParagraphs(t('butlerJob.places.note')).map((para, i) => (
          <p key={i} className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed mt-8 max-w-[820px]">
            {para}
          </p>
        ))}
      </div>
    </section>
  );
}
